import React, { useEffect, useState } from "react";
import { Image, CloudinaryContext } from "cloudinary-react";
import { useNavigate } from "react-router-dom";

const cloudName = "your-cloud-name"; // Replace with your Cloudinary cloud name

const applyPolaroidEffect = (imageUrl) => {
  return `https://res.cloudinary.com/${cloudName}/image/upload/e_sepia:60,e_grain/e_vignette:50/l_polaroid_frame,w_1.0,c_scale,g_center,x_10,y_10/${imageUrl}`;
};

const PolaroidFilterComponent = () => {
  const [photos, setPhotos] = useState([]);
  const [originalPhotos, setOriginalPhotos] = useState([]);
  const [isVintageApplied, setIsVintageApplied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const storedPhotos = JSON.parse(localStorage.getItem("capturedPhotos"));
      const retakeStatus = JSON.parse(localStorage.getItem("retakeStatus")) || {
        retakes: 0,
      };

      if (storedPhotos) {
        setPhotos(storedPhotos);
        setOriginalPhotos(storedPhotos);
        if (retakeStatus.retakes >= 1) {
        //   setRetakeAllowed(false);
        }
        applyPolaroidFilter(storedPhotos); // Apply Polaroid filter by default
      } else {
        navigate("/photo-capture");
      }
    } catch (error) {
      console.error(
        "Error loading photos or retake status from local storage:",
        error
      );
    }
  }, [navigate]);

  const applyPolaroidFilter = async (photosToFilter) => {
    try {
      const updatedPhotos = photosToFilter.map((photo) =>
        applyPolaroidEffect(photo)
      );
      setPhotos(updatedPhotos);
      localStorage.setItem("filteredPhotos", JSON.stringify(updatedPhotos));
      setIsVintageApplied(true);
    } catch (error) {
      console.error("Error applying Polaroid effect:", error);
    }
  };

  const toggleVintageEffect = async () => {
    if (isVintageApplied) {
      setPhotos(originalPhotos);
      localStorage.setItem("filteredPhotos", JSON.stringify(originalPhotos));
      setIsVintageApplied(false);
    } else {
      applyPolaroidFilter(originalPhotos);
    }
  };

  return (
    <CloudinaryContext cloudName={cloudName}>
      <div>
        {photos.map((photo, index) => (
          <Image key={index} publicId={photo} />
        ))}
        <button onClick={toggleVintageEffect}>
          {isVintageApplied ? "Remove Vintage Effect" : "Apply Vintage Effect"}
        </button>
      </div>
    </CloudinaryContext>
  );
};

export default PolaroidFilterComponent;
